import { Panel } from "../../../components/panels/Panel";
import { HoverTextButton } from "../../../components/buttons/HoverTextButton";
import { PlusIcon, Squares2X2Icon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { Modal } from "../../../components/modals/Modal";
import {
  createDateRange,
  loadLayout,
  loadLayoutData, saveLayoutData,
  VIEW_MODE_GLOBAL
} from "../../../services/ergonomics/ergonomics-service";
import { deleteData, postData, useGetData } from "../../../services/api/api-tools";
import { Loader } from "../../../components/loading/Loader";
import { useErgonomicsContext } from "../../../contexts/ErgonomicsContext";
import Badge from "../../../components/logs/Badge";
import { Menu } from "../../../components/menu/Menu";
import { ErgonomicsFatigueIndex } from "./ErgonomicsFatigueIndex";

const ErgonomicsView = ({ view, views }) => {

  const { setLayout, setSelectedDateRange, setZoomDateRange, setLayoutData, layoutData } = useErgonomicsContext();

  const [menu, setMenu] = useState(null);

  const handleContextMenu = (event) => {
    event.preventDefault();
    setMenu({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
      alert,
    });
  };

  const handleClose = () => {
    setMenu(null);
  };

  const handleDeleteView = async () => {
    try {
      const response = await deleteData('ergonomics_views', view.id);
      await views.refetch();
    } catch (error) {
      console.error('Error while deleting view from database.', error);
      return null;
    }
  };

  const handleLoadView = (view) => {
    setLayout(view.layout);
    setLayoutData({ ...view.layout_data, id: view.id});
    setSelectedDateRange(createDateRange(view.layout_data.start, view.layout_data.stop));

    if (view.layout_data?.zoomDateRange?.start !== undefined){
      setTimeout(() => {
        setZoomDateRange(createDateRange(Math.round(view.layout_data.zoomDateRange.start), Math.round(view.layout_data.zoomDateRange.end)));
      }, 2000);
    }
    else
      setZoomDateRange(null);

    views.refetch();
  };

  const textColor = view.id === layoutData.id ? 'text-white' : '';
  const buttonColor = view.id === layoutData.id ? 'bg-perception-blue' : 'bg-perception-gray-700';

  return (
    <>
      <button key={view.id} onClick={() => handleLoadView(view)}
        onContextMenu={handleContextMenu}
        className={`cursor-pointer ${buttonColor} p-2 py-1 rounded-md flex items-center hover:bg-perception-blue hover:text-white ${textColor} text-sm`}>
        <Squares2X2Icon className='w-4 h-4 mr-2' /> {view.name}
      </button>
      {menu &&
        <Menu menu={menu} setMenu={setMenu} onClose={handleClose}>
          <span className='p-2 px-4 cursor-pointer text-start hover:bg-perception-blue' onClick={handleDeleteView}>
            Delete
          </span>
        </Menu>
      }
    </>
  );
};

const ErgonomicsViewPanel = () => {

  const { viewMode, layoutData, setLayoutData } = useErgonomicsContext();

  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState('');

  const handleValueChange = (e) => {
    setValue(e.target.value);
  };

  const closeModal = () => {
    setValue('');
    setIsOpen(false);
  };

  const saveView = async () => {
    try {
      const viewBody = {
        name: value,
        layout: loadLayout(),
        layout_data: loadLayoutData(),
      }
      const response = await postData('ergonomics_views', viewBody);

      const newLayoutData = { ...layoutData, id: response.id };
      setLayoutData(newLayoutData);
      saveLayoutData(newLayoutData, false);
      await views.refetch();
    } catch (error) {
      console.error('Error creating new view in database.', error);
      return null;
    }
  };

  const views = useGetData('ergonomics_views', 'ergonomics_views');

  if (views.isLoading) return <Loader/>

  return (
    <>
      <Modal isOpen={isOpen} setIsOpen={closeModal}>
        <div className='p-4'>
          <h3 className='text-lg text-start font-medium leading-6 text-gray-900'>Nommer la vue</h3>
          <div className='my-4'>
            <input type="text" className="bg-gray-200 p-2 rounded-sm w-full" value={value} onChange={handleValueChange} />
          </div>
          <div className='flex justify-start'>
            <button
              className='inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50'
              onClick={closeModal}
            >
              Annuler
            </button>
            <button
              className='ml-4 inline-flex justify-center rounded-md border border-transparent bg-perception-blue px-4 py-2 text-sm font-medium text-white shadow-sm'
              onClick={() => {
                saveView();
                closeModal();
              }}
              disabled={value === ''}
            >
              Valider
            </button>
          </div>
        </div>
      </Modal>


      <Panel title="VUES ENREGISTREES" height="h-2/6">
        {/* View mode */}
        <div className="mb-4">
          <Badge text={viewMode === VIEW_MODE_GLOBAL ? 'VUE GLOBALE' : 'VUE DÉTAILLÉE'} type="gray"/>
        </div>

        <div className="h-full group/btn">
          {views.data.length > 0 &&
            <div className='flex items-start flex-wrap gap-2 mb-4'>
              {views.data.map((view) => <ErgonomicsView key={view.id} view={view} views={views}/>)}
            </div>
          }
          <div>
            <HoverTextButton onClick={() => setIsOpen(true)} disabled={false}>
              <PlusIcon className='w-4 h-4' />
              <span className='pl-2'>Créer une nouvelle vue</span>
            </HoverTextButton>
          </div>
        </div>
      </Panel>
    </>
  );
};


export const ErgonomicsRightPanel = () => {

  return (
    <div className="h-full flex flex-col justify-between">
      <ErgonomicsViewPanel/>

      <Panel title="INDICE DE FATIGUE GENERALE D'HIER" height="h-3/6" noPadding={true}>
        <div className="h-full flex items-center">
          <ErgonomicsFatigueIndex/>
        </div>
      </Panel>
    </div>
  );
};